import { type ApiKeyAuthClient } from '@automation-suite/shared-clients-api-key-auth';
import { type HttpClient } from '@automation-suite/shared-clients-http';
import { buildUrl } from '@automation-suite/shared-utils-helpers';

import { type CreateAnalyticEventsRequest } from './types';

export type EIPClientOptions = {
  apiKeyAuthClient: ApiKeyAuthClient;
  baseUrl?: string;
  httpClient: HttpClient;
};

export class EIPClient {
  private readonly apiKeyAuthClient: EIPClientOptions['apiKeyAuthClient'];
  private readonly baseUrl: EIPClientOptions['baseUrl'];
  private readonly httpClient: EIPClientOptions['httpClient'];

  constructor({ apiKeyAuthClient, baseUrl = process.env['EIP_URL'], httpClient }: EIPClientOptions) {
    this.baseUrl = baseUrl;
    this.httpClient = httpClient;
    this.apiKeyAuthClient = apiKeyAuthClient;
  }

  private async getSharedHeaders() {
    return {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Api-Key': await this.apiKeyAuthClient.getApiKey(),
    };
  }

  public async createAnalyticEvents({ events }: CreateAnalyticEventsRequest) {
    const url = buildUrl({
      baseUrl: this.baseUrl,
      params: {
        eventType: 'analytics',
      },
      path: '/stream',
    });

    return await this.httpClient.post(url, events, {
      headers: await this.getSharedHeaders(),
    });
  }
}
